// import _ from 'underscore';
function fact(n) {
    var f = 1;
    for (var i = 2; i <= n; ++i)
        f *= i;
    return f;
}


function comb(n, k) {
    var aux = 1;
    for (var i = k + 1; i <= n; ++i)
        aux *= i;
    return aux / fact(n - k);
}
function cotaCastig(val) {
    var coteFixe = []
    var position = val.bilet.position;
    var odds = val.bilet.odds;
    var numereArr = val.bilet.numereArr;
    var value = val.bilet.miza;
    var max_win = val.defaultVal.max_win;
    var bet_tax = val.defaultVal.bet_tax;

    var chk = val.bilet.checked;

    var game_type2 = val.bilet.gameType.split('/');
    var n = numereArr.length;	//nr bile rosii
    var oddNum = odds.length;
    var calc = n;
    var sum = [];
    var a = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    var bet = value;
    if (oddNum > n) {
        oddNum = n;
    }


    /* Get checked systems */
    for (var i = 1; i <= chk.length; i++) {
        var i2 = i - 1
        a[chk[i2]] = 1;
    }

    var betTax = 1 + bet_tax / 100;

    var coeficientMiza = Math.round(bet * 100.0 / betTax) / 100.0;

    //Calculare numar total de combinatii
    var num = 0;
    for (var j = 1; j <= oddNum; ++j) {
        num = num + (comb(n, j) * a[j]);
    }
    // console.log(num);
    //Calculare miza pe combinatie

    var mizaCombinatie = 1 / num;

    for (var k = 1; k <= calc; k++) {

        var new_sum = 0;
        // console.log(odds);
        //Adunam toate sistemele castigatoare cuprinse de sistemul curent
        for (var q = 1; q <= oddNum && q <= k; ++q) {
            var termen = 0;
            termen = a[q] * comb(k, q) * odds[q - 1];
            // console.log(odds[i - 1]);
            new_sum = new_sum + termen * mizaCombinatie;
        }
        //Asignam castigul pentru sistemul k
        // console.log(100 * new_sum * coeficientMiza / 100.0)
        sum[k - 1] = Math.round(100 * new_sum * coeficientMiza) / 100.0;
        // console.log(sum[k - 1])
        // if (sum[k - 1] >= max_win) {
        //     sum[k - 1] = max_win;
        // }

    }
    var minBile_GameType = Math.min(game_type2[0], sum.length) - 1;
    var cota = Math.round(100 * sum[minBile_GameType] / coeficientMiza) / 100;
    var castigEventual = sum[minBile_GameType];

    // console.log('castigEventual - ', calc)
    if (castigEventual > max_win) {
        castigEventual = max_win;

    }

    // if (chk.length < 1) {
    //     castigEventual = 0;
    //     cota = 0;
    // }
    // console.log(chk.length, cota, castigEventual, bet)
    if ((chk.length < 1) || (isNaN(cota) === true) || (isNaN(castigEventual) === true) || (isNaN(bet) === true) || (bet < 0)) {
        castigEventual = 0;
        cota = 0;
    }

    // var castigEv = castigEventual;

    // this.cotaf(idR, cota, numeLot)
    // this.castigEv(idR, castigEventual, numeLot)

    // Calcul cote fixe
    var hitsMaxNb
    if (numereArr.length <= odds.length) {
        hitsMaxNb = numereArr.length
    } else {
        hitsMaxNb = odds.length
    }

    // console.log("info cote Fixe!***", odds, oddNum, numereArr, chk, '=>>', val.bilet)
    coteFixe = []
    var sumaNumarator = [], sumaNumitor = []
    for (var hit = 0; hit < hitsMaxNb; hit++) {
        sumaNumarator.push(0)
        sumaNumitor.push(0)
        for (var hit_index = 0; hit_index < chk.length; hit_index++) {

            if (chk[hit_index] <= hit + 1) {
                var combN = comb(hit + 1, chk[hit_index])
                // console.log('jkfdkkf', hit + 1, chk[hit_index], combN);
                var combNumit = comb(numereArr.length, chk[hit_index])
                // console.log('numarator', combN, odds[hit_index], 'numitor', combNumit);
                sumaNumarator[hit] = sumaNumarator[hit] + combN * odds[chk[hit_index] - 1]
                // console.log('sumaNumarator', hit, chk[hit_index], odds[chk[hit_index] - 1], combN, sumaNumarator[hit]);
            }
            sumaNumitor[hit] = sumaNumitor[hit] + combNumit
        }
    }
    // console.log('sume finale', sumaNumarator, sumaNumitor);
    if (sumaNumarator.length === sumaNumitor.length) {
        for (var fin = 0; fin < sumaNumarator.length; fin++) {
            coteFixe.push(
                Math.round((sumaNumarator[fin] / sumaNumitor[fin]) * 100.0) / 100.0
            )
        }
    }
    // console.log('coteFixe', coteFixe);
    // END Calcul cote fixe

    var sum2 = []
    for (var z = 0; z < sum.length; z++) {
        if (sum[z] >= max_win) {
            sum2[z] = max_win;
        } else {
            sum2[z] = sum[z];
        }


    }
    var result = {
        position: position,
        cotaTot: cota,
        castigEventual: castigEventual,
        sum: sum2,
        sumDefault: sum,
        coteFixe: coteFixe
    }
    return result;
}

export function acCalculBilet(val) {
    var sumR = cotaCastig(val)
    // console.log('acCalculBilet - ', sumR);
    return {
        type: 'BILET_CALCUL',
        payload: sumR
    }

}